export default __webpack_public_path__ + "static/treeLeft-069dc6a8798f8a7f98ce9edb50a049d1.png";